import { OnboardingLayout } from "@bcc/components/onboarding-layout";
import { OnboardingSuccess } from "@bcc/components/onboarding/onboarding-success";

export function OnboardingSuccessPage() {
  return (
    <OnboardingLayout>
      <OnboardingSuccess />
    </OnboardingLayout>
  );
}
